import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const PostOnIdealistDropdownMobileText = styled.span`
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const PostOnIdealistDropdownDesktopText = styled.span`
  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;
